import { render } from "./EntryMedia.vue?vue&type=template&id=32925b49"
import script from "./EntryMedia.vue?vue&type=script&lang=ts"
export * from "./EntryMedia.vue?vue&type=script&lang=ts"
script.render = render

export default script